import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ShieldCheckFillIcon = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.680664C12.7072 0.680664 10.5451 1.17818 8.50936 1.73001C6.42793 2.29423 4.33093 2.95806 3.0974 3.36057C2.06797 3.69648 1.28935 4.60615 1.13981 5.72834C0.0211394 14.1233 2.61508 20.3435 5.76125 24.4594C7.32843 26.5096 9.03169 28.0376 10.4808 29.0595C11.2048 29.5701 11.8759 29.9617 12.4457 30.2299C12.9722 30.4778 13.5356 30.6807 14 30.6807C14.4644 30.6807 15.0278 30.4778 15.5543 30.2299C16.1241 29.9617 16.7952 29.5701 17.5192 29.0595C18.9683 28.0376 20.6716 26.5096 22.2387 24.4594C25.3849 20.3435 27.9789 14.1233 26.8602 5.72834C26.7107 4.60615 25.932 3.69648 24.9026 3.36057C23.6691 2.95805 21.5721 2.29423 19.4906 1.73001C17.4549 1.17818 15.2928 0.680664 14 0.680664ZM18.0246 10.3303C18.3907 9.96414 18.9843 9.96414 19.3504 10.3303C19.7165 10.6964 19.7165 11.29 19.3504 11.6561L13.7254 17.2811C13.5496 17.4569 13.3111 17.5557 13.0625 17.5557C12.8139 17.5557 12.5754 17.4569 12.3996 17.2811L9.58709 14.4686C9.22097 14.1025 9.22097 13.5089 9.58709 13.1428C9.9532 12.7766 10.5468 12.7766 10.9129 13.1428L13.0625 15.2923L18.0246 10.3303Z",
    fill: color
  }));
};
export default ShieldCheckFillIcon;